import Vue from 'vue'
const eventBus = new Vue({
  data() {
    return {
      filter: {
        orderName: ''
      }
    }
  }
})
Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return eventBus
    }
  }
})
